/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Footer_DiscordInputs */

const en_fc_footer_discord = /** @type {(inputs: Fc_Footer_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft Discord`)
};

/**
* | output |
* | --- |
* | "ArtCraft Discord" |
*
* @param {Fc_Footer_DiscordInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_footer_discord = /** @type {((inputs?: Fc_Footer_DiscordInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Footer_DiscordInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_footer_discord(inputs)
});
export { fc_footer_discord as "fc.footer.discord" }